import {languages as BasicLanguages, global as BasicGlobal} from '@src/assets/data/constants'
const languages = {...BasicLanguages}
const global = {...BasicLanguages}

export {languages, global}
